export const TaskPriorityTag = ({ task }: any) => {
  const priority = task?.priority ?? task?._priority;
  return priority ? (
    <div className={`task-priority-tag ${priority ? priority?.toLowerCase() : 'low'}`}>
      {priority}
    </div>
  ) : null;
};
